type Params = {
  src: string,
  module: boolean,
  namespace?: string,
  onLoad: () => void,
  onError: () => void,
};

const loadScript = ({
  src, module = false, namespace, onLoad = () => {}, onError = () => {},
}: Params) => {
  const script = document.createElement('script');
  script.setAttribute('src', src);
  if (module) {
    script.setAttribute('type', 'module');
  } else {
    script.setAttribute('nomodule', '');
  }
  if (namespace) {
    script.setAttribute('namespace', namespace);
  }
  script.addEventListener('load', onLoad);
  script.addEventListener('error', onError);
  document.body.appendChild(script);
};

export default loadScript;
